import globals from './globals';

export default () => {
  const hamburgerButton = document.querySelector('.c-header__hamburger');

  if (hamburgerButton !== null) {
    hamburgerButton.addEventListener('click', event => {
      event.preventDefault();
      globals.html.classList.add('is-menu-open');
    });
  }

  const menuCloseButton = document.querySelector(
    '.c-header__navigation .c-navigation__close',
  );

  if (menuCloseButton !== null) {
    menuCloseButton.addEventListener('click', event => {
      event.preventDefault();
      globals.html.classList.remove('is-menu-open');
    });

    const headerNavigation = document.querySelector('.c-header__navigation');

    headerNavigation.addEventListener('click', event => {
      if (event.target === headerNavigation) {
        event.preventDefault();
        globals.html.classList.remove('is-menu-open');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/header.js